import { useState, type Dispatch, type SetStateAction } from 'react';
import MultiSelect from '../../components/inputs/MultiSelect';
import { UserService } from '../configuracoes/usuario/Service';
import { baseURL } from '../../AxiosConfig';

const userService = new UserService();

export type ClientOption = {
    value: string;
    label: string;
};

interface ClientSelectProps {
    value: string;
    onChange: (value: string) => void;
    clients: ClientOption[];
    setClients: Dispatch<SetStateAction<ClientOption[]>>;
    loading?: boolean;
    disabled?: boolean;
    canCreate?: boolean;
    label?: string;
    placeholder?: string;
    onCreateError?: (message: string) => void;
    menuOverlay?: boolean;
}

export default function ClientSelect({
    value,
    onChange,
    clients,
    setClients,
    loading = false,
    disabled = false,
    canCreate = true,
    label = 'Cliente',
    placeholder = 'Selecione o cliente',
    onCreateError,
    menuOverlay = false,
}: ClientSelectProps) {
    const [inputValue, setInputValue] = useState('');
    const [creating, setCreating] = useState(false);

    const filteredOptions = clients
        .filter((client) => client.label.toLowerCase().includes(inputValue.toLowerCase()))
        .slice(0, 10);

    if (value && !filteredOptions.some((client) => client.value === value)) {
        const selectedClient = clients.find((client) => client.value === value);
        if (selectedClient) {
            filteredOptions.unshift(selectedClient);
        }
    }

    const handleCreateClient = async (name: string) => {
        const normalizedName = String(name || '').trim();
        if (!normalizedName) return;

        setCreating(true);
        try {
            const { data } = await userService.createClient({ name: normalizedName });
            const newOption = { value: data.uid, label: normalizedName };
            setClients((prev) => [...prev, newOption]);
            onChange(data.uid);
        } catch (error) {
            console.error('Erro ao criar cliente da venda', error);
            onCreateError?.('Não foi possível criar o cliente agora.');
        } finally {
            setCreating(false);
        }
    };

    return (
        <MultiSelect
            options={filteredOptions}
            loading={loading || creating}
            disabled={disabled}
            value={value}
            onChange={(selected) => onChange(String(selected || ''))}
            onCreateOption={canCreate ? handleCreateClient : undefined}
            creatable={canCreate}
            menuOverlay={menuOverlay}
            placeholder={placeholder}
            formatOptionLabel={(option: any) => (
                <div className="flex items-center gap-2">
                    <img
                        src={`${baseURL}/users/profileImage/${option?.value}`}
                        alt="Avatar do usuário"
                        className="w-6 h-6 rounded-full object-cover"
                    />
                    <span>{option.label}</span>
                </div>
            )}
            label={label}
            name="cliente"
            multiple={false}
            onInputChange={(nextValue: string) => setInputValue(nextValue)}
        />
    );
}
